import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';

import SideMenu from '../shared/sidemenu/SideMenu';
import Government from './settings/Government';
import Company from './settings/Company';
import Profile from './settings/Profile';
import Support from './settings/Support';
import End from './settings/End';
import SettingsListItem from '../settings/SettingsListItem';
import { getText, trackGA } from 'misc/helpers';

class Settings extends Component {
    render = () => {
        return (
            <div className="main-content">
                <SideMenu />
                <article className="list-content settings animation-fade-in">
                    <div className="padded-content">
                        <h2>{getText('_3_2_TitelSender', 'Avsändare')}</h2>
                        <ul>
                            <SettingsListItem label={getText('_3_2_TitelAuthoritiesletters', 'Myndighetspost')} url="government" />
                            <SettingsListItem label={getText('_3_2_TitelCompany', 'Företag')} url="company" />
                        </ul>
                        <h2>{getText('_3_2_TitelOther', 'Övrigt')}</h2>
                        <ul>
                            <SettingsListItem label={getText('_3_2_TitelProfil', 'Profil')} url="profile" />
                            <SettingsListItem label={getText('_12_3_Titel_support', 'Support')} url="support" />
                            {/*<SettingsListItem label={getText('_3_2_TitelExitServiceAtDigimail', 'Avsluta Digimail')} url="end" />*/}
                        </ul>
                    </div>
                </article>
                <aside className="view-content">
                    <Route path="/settings/government" component={Government} />
                    <Route path="/settings/company" component={Company} />
                    <Route path="/settings/support" component={Support} />
                    <Route path="/settings/profile" component={Profile} />
                    <Route path="/settings/end" component={End} />
                </aside>
            </div>
        );
    };

    componentDidMount() {
        trackGA('3.2 Inställningar');
    }
}

const mapStateToProps = (state, ownProps) => {
    return {};
};

export default connect(mapStateToProps)(Settings);



// WEBPACK FOOTER //
// ./src/components/views/Settings.js